import { v4 as uuid } from 'uuid';

const UIFrameworkStore = {};
const createTopic = (Topic, Data) => {
  UIFrameworkStore[Topic] = {};
  UIFrameworkStore[Topic].CallBacks = {};
  UIFrameworkStore[Topic].Data = Data;
};
export const Subscribe = (Topic, SubCallback) => {
  const key = uuid();
  if (!UIFrameworkStore[Topic]) {
    createTopic(Topic, null);
  }
  UIFrameworkStore[Topic].CallBacks[key] = SubCallback;
  if (UIFrameworkStore[Topic] && UIFrameworkStore[Topic].Data) {
    SubCallback(UIFrameworkStore[Topic].Data);
  }
  // return key;
  return () => {
    if (UIFrameworkStore[Topic]) {
      delete UIFrameworkStore[Topic].CallBacks[key];
    }
  };
};
export const Publish = (Topic, Data) => {
  if (UIFrameworkStore[Topic]) {
    UIFrameworkStore[Topic].Data = Data;
    if (UIFrameworkStore[Topic].CallBacks) {
      Object.keys(UIFrameworkStore[Topic].CallBacks).forEach((func) => {
        UIFrameworkStore[Topic].CallBacks[func](UIFrameworkStore[Topic].Data);
      });
    }
  } else {
    createTopic(Topic, Data);
  }
};
